export const tr = {
  // Header
  header: {
    home: 'Ana Sayfa',
    nonSurgicalAesthetics: 'Ameliyatsız Estetik',
    surgicalProcedures: 'Cerrahi İşlemler',
    about: 'Hakkımızda',
    blog: 'Blog',
    contact: 'İletişim',
    expertDoctor: 'Uzman Doktor',
    aestheticsInTurkey: 'Türkiye\'de Estetik',
    paymentMethods: 'Ödeme Yöntemleri',
    kvkk: 'KVKK',
    rhinoplasty: 'Burun Estetiği',
    liposuction: 'Liposuction',
    bbl: 'Brezilya Poposu Estetiği',
    tummyTuck: 'Karın Germe',
    breastAugmentation: 'Meme Büyütme',
    breastLift: 'Meme Dikleştirme',
    breastReduction: 'Meme Küçültme',
    gynecomastia: 'Jinekomasti',
    armLift: 'Kol Germe',
    thighLift: 'Uyluk Germe',
    genitalAesthetics: 'Genital Bölge Estetiği',
    postBariatricSurgery: 'Post Bariatrik Cerrahi',
    medicalAesthetics: 'Medikal Estetik',
    wrinkleTreatment: 'Kırışıklık ve Terleme Tedavisi',
    skinFiller: 'Cilt Dolgusu',
    skinCare: 'Cilt Bakımı',
    medicalSkinCare: 'Medikal Cilt Bakımı',
    aquapeelSkinCare: 'Aquapeel Cilt Bakımı',
    dermapenApplication: 'Dermapen Uygulaması',
    pumpkinPeel: 'Pumpkin Peel',
    regionalSlimming: 'Bölgesel İncelme',
    g5Massage: 'G5 Masaj',
    threadLifting: 'İple Askılama',
    mesotherapy: 'Mezoterapi',
    facialAesthetics: 'Yüz Estetiği',
    eyebrowLift: 'Kaş Kaldırma',
    earCorrection: 'Kepçe Kulak Estetiği',
    dimpleAesthetics: 'Gamze Estetiği',
    facialFatInjection: 'Yüze Yağ Enjeksiyonu',
    faceLift: 'Yüz Germe',
    foreheadLift: 'Alın Germe',
    neckLift: 'Boyun Germe',
    buccalFatRemoval: 'Bişektomi',
    moleRemoval: 'Ben (Nevüs) Alınması',
    chinLiposuction: 'Gıdı Liposuction',
    bodyAesthetics: 'Vücut Estetiği',
    breastAesthetics: 'Göğüs Estetiği'
  },
  // Footer
  footer: {
    contact: 'İletişim',
    address: 'Adres',
    phone: 'Telefon',
    email: 'E-posta',
    workingHours: 'Çalışma Saatleri',
    weekdays: 'Pazartesi - Cuma',
    saturday: 'Cumartesi',
    allRightsReserved: 'Tüm hakları saklıdır',
    socialMedia: 'Sosyal Medya',
    aestheticsInTurkey: 'Türkiye\'de Estetik',
    paymentMethods: 'Ödeme Yöntemleri',
  },
  // Homepage
  homepage: {
    hero: {
      title: 'Estetik ve Güzellik',
      subtitle: 'Güzelliğiniz İçin Profesyonel Çözümler',
      description: 'Uzman kadromuz ve modern tekniklerimizle estetik ihtiyaçlarınız için en iyi hizmeti sunuyoruz.',
      button: 'Randevu Al',
      slides: {
        rhinoplasty: {
          title: 'Burun Estetiği',
          description: 'Yüzünüzle uyumlu, doğal bir burun hayal değil! Burun estetiği ile hem nefes alın, hem özgüven kazanın. Güzelliğinize zarif bir dokunuş yapma zamanı! Modern teknikler ve uzman dokunuşuyla farkı hissedin. Aynaya her baktığınızda memnuniyetle gülümseyin.',
          infoButton: 'Burun Estetiği Bilgi Sayfası'
        },
        liposuction: {
          title: 'Liposuction (Yağ Aldırma)',
          description: 'Hayalinizdeki vücut artık mümkün! Modern liposuction yöntemleriyle fazla yağlara veda edin. Şimdi formunuzu yeniden şekillendirme zamanı! Bölgesel fazlalıklar tarihe karışıyor, siz yeniden doğuyorsunuz.',
          infoButton: 'Liposuction Bilgi Sayfası'
        },
        bbl: {
          title: 'Brazilian Butt Lift (BBL)',
          description: 'Daha dolgun, şekilli ve doğal kalçalar! Brazilian Butt Lift ile vücudunuza kıvrım katın. Yeni görünümünüzle kendinize hayran kalacaksınız! Kendi yağınızla doğal ve kalıcı sonuçlar elde edin.',
          infoButton: 'BBL Bilgi Sayfası'
        }
      }
    },
    services: {
      title: 'Hizmetlerimiz',
      subtitle: 'Modern teknikler ve uzman kadromuzla sizlere en iyi hizmeti sunuyoruz',
      cards: {
        rhinoplasty: {
          title: 'Burun Estetiği',
          description: 'Yüzünüzle uyumlu, doğal bir burun için uzman doktorlarımızla tanışın.',
          button: 'Detaylı Bilgi',
        },
        faceLift: {
          title: 'Yüz Estetiği',
          description: 'Genç ve dinamik bir görünüm için yüz estetiği operasyonları.',
          button: 'Detaylı Bilgi',
        },
        bodyAesthetics: {
          title: 'Vücut Estetiği',
          description: 'Hayalinizdeki vücuda kavuşmak için profesyonel çözümler.',
          button: 'Detaylı Bilgi',
        },
      },
    },
    testimonials: {
      title: 'Hasta Yorumları',
      subtitle: 'Hastalarımızın deneyimleri ve memnuniyetleri bizim için en değerli geri bildirimdir',
      viewAll: 'Tüm Yorumları Gör',
      items: {
        rhinoplasty: {
          name: 'Ayşe K.',
          location: 'İstanbul',
          comment: 'Burun estetiği operasyonum sonrası çok memnunum. Dr. Barış Çin\'in profesyonel yaklaşımı ve uzmanlığı sayesinde hayalimdeki buruna kavuştum. Tüm süreç boyunca kendimi güvende hissettim.',
          rating: 5
        },
        liposuction: {
          name: 'Ceren N.',
          location: 'Ankara',
          comment: 'Liposuction operasyonum sonrası vücudumdaki değişim inanılmaz. Dr. Barış Çin ve ekibine teşekkürler. Artık kendime daha çok güveniyorum.',
          rating: 5
        },
        bbl: {
          name: 'Zeynep A.',
          location: 'İzmir',
          comment: 'BBL operasyonum sonrası çok mutluyum. Dr. Barış Çin\'in tecrübesi ve titiz çalışması sayesinde harika sonuçlar elde ettim. Kesinlikle tavsiye ediyorum.',
          rating: 5
        }
      }
    },
    satisfactionVideos: {
      title: 'Hasta Memnuniyet Videoları',
      subtitle: 'Hastalarımızın deneyimlerini ve memnuniyetlerini video olarak izleyin',
      viewAll: 'Tüm Videoları Gör',
      items: {
        rhinoplasty: {
          title: 'Burun Estetiği Deneyimi',
          description: 'Burun estetiği operasyonu sonrası hasta deneyimi ve memnuniyeti',
          duration: '3:45'
        },
        liposuction: {
          title: 'Liposuction Deneyimi',
          description: 'Liposuction operasyonu sonrası hasta deneyimi ve memnuniyeti',
          duration: '4:20'
        },
        bbl: {
          title: 'BBL Deneyimi',
          description: 'Brazilian Butt Lift operasyonu sonrası hasta deneyimi ve memnuniyeti',
          duration: '3:55'
        }
      }
    },
    about: {
      title: 'Hakkımızda',
      readMore: 'Devamını Oku',
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Estetik ihtiyaçlarınız için bizimle iletişime geçin',
      name: 'Adınız',
      phone: 'Telefonunuz',
      phoneValue: '+90 555 123 4567',
      message: 'Mesajınız',
      send: 'Mesaj Gönder',
      address: 'Adres',
      addressValue: 'Koşuyolu Mahallesi Mehmet Akfan Sokak No:19-21 Kadıköy İstanbul Türkiye',
      email: 'E-posta',
      emailValue: 'drbariscin86@gmail.com',
      workingHours: 'Çalışma Saatleri',
      workingHoursValue: 'Pazartesi - Cuma: 09:00 - 18:00',
      socialMedia: 'Sosyal Medya',
      socialMediaDescription: 'En son güncellemeler ve bilgiler için sosyal medyada bizi takip edin',
      location: 'Konum',
      locationDescription: 'Muayenehanemiz Kadıköy\'ün merkezinde yer almakta olup toplu taşıma araçlarına kolay erişim sağlamaktadır',
      appointment: 'Randevu',
      appointmentDescription: 'Randevu almak ve detaylı bilgi için hemen bizimle iletişime geçin'
    },
    credentials: {
      title: 'Yetki Belgelerimiz',
      subtitle: 'Sağlık Bakanlığı onaylı yetki belgelerimiz ve uluslararası sağlık turizmi sertifikalarımız',
      healthTurkiyeTitle: 'Health Türkiye',
      healthTurkiyeDescription: 'Türkiye Cumhuriyeti Sağlık Bakanlığı Sağlık Turizmi Yetki Belgesi',
      certificateTitle: 'Yetki Belgesi',
      certificateDescription: 'Resmi yetki belgemizi PDF olarak görüntüleyin',
      viewDocument: 'Belgeyi Görüntüle',
      viewImage: 'Büyüt'
    },
    doctorIntro: {
      title: "UZMAN DOKTOR",
      name: "Op. Dr. Barış Çin",
      description: "Op. Dr. Barış Çin, Kadıköy'de bulunan kendisine ait özel muayenehanesinde ve Academic, Acıbadem Hastaneleri gibi çeşitli üst düzey hastaneler ile çalışan bir Plastik Cerrahtır. Mükemmellik için çabalayan bir ekip ile beraber size en üst düzeyde estetik tedavileri uygun fiyatlarla sunmak için ekip olarak 7/24 hizmetinizdedir. Hayallerinizi ertelemeyin, mutlu ve güzel olun!",
      features: {
        experience: "15+ yıllık deneyim ile binlerce başarılı operasyon",
        technology: "Modern teknikler ve en son teknolojik ekipmanlar",
        approach: "Kişiye özel tedavi planları ve yaklaşımlar"
      },
      button: "Randevu Al"
    },
  },
  // WhatsApp messages
  whatsapp: {
    appointmentMessage: "Merhaba, randevu almak istiyorum."
  },
  about: {
    aestheticsInTurkey: {
      title: "Türkiye'de Estetik",
      content: {
        intro: "Türkiye'de Estetik Ameliyat ve Türkiye'ye Seyahat Etmek ile İlgili Merak Edilenler",
        advantages: {
          title: "Türkiye'de Estetik Ameliyat Olunur Mu?",
          items: [
            "Türkiye, son yıllarda yurt dışından gelen binlerce yabancı turistin estetik ameliyat (liposuction, karın germe, meme büyütme/dikleştirme vb.) olmak için tercih ettiği ülkelerin başında gelmektedir.",
            "Estetik ameliyat olmak için binlerce yabancı turistin Türkiye'yi tercih etmesinin sebebi, Türkiye'nin tarih ve sanat alanındaki kültürel değerlerinin yanı sıra sağlık alanında da gelişmiş teknoloji ile JCI akrediteye (Joint Commision International) sahip hastanelere ve oldukça başarılı cerrahlara ev sahipliği yapıyor olmasıdır.",
            "Eğer siz de sahip olmak istediğiniz bedene ulaşmak için gerekli olan estetik ameliyatı İstanbul'da olmak isterseniz, İstanbul'daki muayenehanesinde hizmet veren ve Avrupa Board Sertifikası sahibi bir cerrah olan Dr. Barış Çin ve ekibi ile tanışmalısınız.",
            "10 yıllık deneyim ile Dr. Barış Çin ve ekibi tarafından ihtiyaç duyduğunuz estetik operasyonlar yıllardır başarı ile gerçekleştirilmektedir."
          ]
        },
        statistics: {
          title: "Yılda kaç yabancı turist Türkiye'de estetik ameliyat olmayı tercih ediyor?",
          description: "Sağlık turizmi alanında oldukça başarılı ve gözde olan Türkiye'ye sadece 2022 yılının ilk yarısında 600.000 yabancı turist estetik ve diğer ameliyatları gerçekleştirmek için geldi."
        },
        procedures: {
          title: "Türkiye'deki gerçekleştirilen en popüler 10 estetik ameliyat nedir?",
          items: [
            "Rinoplasti",
            "Meme Küçültme",
            "Liposuction",
            "Meme Büyütme",
            "Göz Kapağı Estetiği",
            "Karın germe",
            "Kepçe Kulak",
            "Bişektomi",
            "BBL",
            "Göz kenarı estetiği"
          ],
          additional: "Ancak Türkiye'de uygulanan estetik ameliyatlar bunlarla sınırlı değildir. Bunların yanı sıra, yüz germe, kol germe, uyluk germe, sırt germe, vajina estetiği, kaş kaldırma, şakak kaldırma, tilki göz ameliyatları da başarı ile gerçekleştirilmektedir."
        },
        istanbul: {
          title: "Neden İstanbul'da estetik ameliyat olmalısınız?",
          description: "Estetik ameliyat olmak için İstanbul'u tercih etmenin birden fazla sebebi bulunmaktadır.",
          history: "İstanbul Türkiye'nin en gelişmiş ve büyük şehridir. İstanbul, Dünya'da hem Asya hem de Avrupa kıtasında yer alan tek şehirdir. İstanbul'un tarihi M.Ö. 8500 yıllarına dayanmakla beraber 330-396 Roma İmparatorluğu döneminde büyük önem kazanmıştır. M.S. 576 yılında yapılan devasa Agios Sofia kilisesi günümüzde hala tüm ihtişamı ile ayaktadır.",
          advantages: "Bir yandan tarihi ve kültürel olarak oldukça zengin olan İstanbul şehrini ziyaret ederken, bir yandan da gelişmiş teknoloji ile JCI akrediteye (Joint Commision International) sahip hastanelerde, oldukça başarılı cerrahlar tarafından, makul ücretlerle estetik ameliyatlara erişme imkânı elde edebilirsiniz."
        }
      }
    },
    paymentMethods: {
      title: "Ödeme Yöntemleri",
      content: {
        intro: "Muayenehanemizde yapılan işlemler için ödeme çeşitleri aşağıdaki gibidir. Ameliyat ve tıbbi işlemlerin ücretleri tüm sağlık kurumlarında olduğu gibi işlem başlamadan önce alınmaktadır. (bazı acil durumlar hariç)",
        deposit: {
          title: "Depozito ve İptal Koşulları",
          description: "Ameliyat edilecek hastalarımızın operasyonları eğer özel hastanede yapılacaksa, hastaneden randevu almak için yaklaşık 300 euro depozito alınmaktadır. Bu depozito eğer ameliyattan 1 hafta önceye kadar iptal edilme durumu olursa aynı şekilde iade edilmektedir. Ancak eğer ameliyat son anda keyfi bir sebepten iptal edilirse hastaneler yeni randevu oluşturamayacakları için cezai ücret almaktadır. Depozito bu ücret düştükten sonra iade edilmektedir. Eğer covid+ olması, enfeksiyon, anestezi tahlilleri sonucu olumsuz gelmesi gibi sebeplerden operasyon iptal edilirse cezai ücret olmamaktadır. Ancak hastanede yapılan kan tahlilli ve diğer işlemlerin ücretleri düşüldükten sonra iade yapılmaktadır. Eğer operasyon veya işlem muayenehanede yapılacaksa depozito alınması söz konusu değildir. Ancak havaalanı transferi olacaksa bunun ödenmesi için depozito alınabilir."
        },
        methods: {
          title: "Ödeme Yöntemleri",
          items: [
            {
              title: "Nakit",
              description: "Muayenehanemizde Türk Lirası, Dolar ve Euro cinsinden ödeme alınmaktadır. Bu yöntemin avantajı komisyon, ve döviz dönüşüm ücreti bulunmamasıdır."
            },
            {
              title: "Fiziki POS",
              description: "Muayenehanemizde İş Bankası'na ait fiziki POS cihazı vardır. Ancak ücretsiz taksitlendirme yapılamamaktadır. Ancak hastalar kredi kartından veya banka kartından çektirdikten sonra kendi bankaları üzerinden vade farkıyla taksit yapabilmektedirler. POS'tan yapılan işlemlerde bankalar kart sahibinden ortalama %2 alıcıdan ortalama %2 komisyon almaktadırlar. Ayrıca döviz çevirmek için DCC (direct currency Exchange) adı altında %6 almaktadırlar. Dolayısıyla işlem ücreti %8-10 kadar artmaktadır."
            },
            {
              title: "Sanal POS",
              description: "Muayenehanemize ulaşamayan, özellikle yurt dışından gelen hastalarımızın depozito ödeyebilmeleri için İş Bankası'na ait sanal pos sistemi üzerinden linkle tahsilat linki gönderebiliyoruz."
            },
            {
              title: "Western Union",
              description: "Muayenehanemize ödeme yapmak için Türkiye İstanbul İş Bankası Ataşehir Şubesi \"Barış Çin\" adına Western Union üzerinden ödeme gönderilebilir. Gönderilecek tutara göre bankalar tarafından %4.4-20 arası işlem ücreti alınmaktadır."
            }
          ]
        },
        bankTransfer: {
          title: "Havale – EFT",
          description: "Aşağıdaki hesap numarasına ödeme için direk havale ve EFT yapılabilir. Yine bankalar tarafından havale ücreti, döviz kuru değiştirilecekse bununla ilgili ücret, ayrıca komisyon alınmaktadır.",
          accounts: {
            try: {
              title: "Türk Lirası",
              bank: "Türkiye İş Bankası Ataşehir Şubesi (1226)",
              iban: "TR23 0006 4000 0011 2260 5541 37"
            },
            eur: {
              title: "Euro Hesabı",
              bank: "Türkiye İş Bankası Ataşehir Şubesi",
              iban: "TR22 0006 4000 0021 2260 4930 40"
            },
            usd: {
              title: "Dolar Hesabı",
              bank: "Türkiye İş Bankası Ataşehir Şubesi",
              iban: "TR67 0006 4000 0021 2260 5016 39"
            }
          }
        },
        swift: {
          title: "SWIFT",
          description: "Yukarıdaki hesaba yurtdışından para göndermek isteyen hastalarımız için, iş bankası swift kodu ISBKTRIS. ABD'den gönderilecek havaleler için CHIPS UID: 003546 (Routing Code, ABA Number yerine de kullanılmaktadır). Diğer taraftan alıcıya havalenin daha kolay ulaşması için alıcının adı, soyadı (Barış Çin) ve adresinin (Koşuyolu Mahallesi Mehmet Akfan Sokak No:19-21 Kadıköy İstanbul Turkey) eksiksiz olarak yazılması, eğer biliniyorsa, alıcıya ait 26 haneli ve TR ile başlayan IBAN (International Bank Account Number: Uluslararası Banka Hesap Numarası TR670006400000212260501639 (dolar))",
          note: "Özellikle yurtdışından yapılan banka transferi ve swift işlemlerinde paranın Türkiye'ye ulaşması 2-3 haftaya kadar uzun sürebilmekte, bazen Avrupa Birliği ülkelerinden yapılan transferler \"dolandırıcılık\" şüphesiyle verifikasyon için askıda kalabilmektedir. Ayrıca paranın hesaba geçmesi için alıcı banka tarafından ücret talep edilebilmektedir. Bu sebeple yurtdışı işlemlerde Nakit ve POS cihazlarının öncelikli olarak tercih edilmesini, eğer EFT ve SWIFT yapılacaksa en az 1 ay öncesinden yapılmasını önermekteyiz. Operasyon veya işlem öncesi talep edilen tutarın tamamı alınmadığı takdirde işlem yapılmamaktadır. EFT ve SWIFT ödemesi yapacak olan hastalarımızın mutlaka aynı döviz cinsinden hesaplar arası transfer yapması gerekmektedir, aksi taktirde gönderilen para alıcı hesaba ulaşmamaktadır. (Türk Lirası'ndan Türk lirası hesabına, dolar hesabından dolar hesabına, euro hesabından euro hesabına gibi..)"
        }
      }
    }
  },
  doctorInfo: {
    title: "Doktor Bilgileri",
    name: "Doktor İsmi",
    specialty: "Uzmanlık Alanı",
    specialtyValue: "Estetik, Plastik ve Rekonstrüktif Cerrahi",
    email: "E-mail",
    phone: "Telefon",
    socialMedia: "Sosyal Medya",
    educationExperience: "Eğitim & Deneyim",
    education: "Eğitim",
    educationValue: "Marmara Üniversitesi, İstanbul, Türkiye",
    experience: "Deneyim",
    experienceValue: "15+ yıl deneyim",
    expertise: "Uzmanlık",
    expertiseValue: "Estetik, Plastik ve Rekonstrüktif Cerrahi Uzmanı",
    biography: "Biyografi",
    biographyText1: "Op. Dr. Barış Çin, Kadıköy'deki özel muayenehanesinde ve aynı zamanda Academic ile Acıbadem Hastaneleri gibi önde gelen sağlık kuruluşlarında hizmet veren deneyimli bir Plastik, Rekonstrüktif ve Estetik Cerrahi uzmanıdır.",
    biographyText2: "Ulusal ve uluslararası düzeyde tanınan bir hekim olarak, alanında uzman ekibiyle birlikte, yüksek kalite standartlarında estetik çözümleri erişilebilir maliyetlerle sunmayı amaçlamaktadır. Hasta memnuniyetini esas alan anlayışıyla, danışanlarına 7/24 destek sağlamaktadır.",
    europeanBoard: "European Board Sertifikası: 6 Nisan 2019, Brüksel / Belçika",
    turkishBoard: "Turkish Board Sertifikası: 28 Eylül 2018, Ankara / Türkiye",
    professionalSkills: "Profesyonel Yetenekler",
    skillsDescription: "Op. Dr. Barış Çin, estetik ve rekonstrüktif cerrahide geniş bir yelpazede uzmanlığa sahiptir. Aşağıda öne çıkan bazı yetenekleri görebilirsiniz:",
    facialAesthetics: "Yüz Estetiği",
    bodyAesthetics: "Vücut Estetiği",
    rhinoplasty: "Rinoplasti",
    breastAesthetics: "Meme Estetiği",
    careerJourney: "Kariyer Yolculuğu",
    careerText1: "Dr. Barış Çin, ilköğretimini Ankara'da tamamladıktan sonra Ankara Gazi Anadolu Lisesi'ni kazanarak burada bir yıl İngilizce hazırlık eğitimi aldı. Ardından ailesiyle birlikte taşındığı Riyad/Suudi Arabistan'da, eğitimine Riyad American International School'da devam etti ve lise eğitimini başarıyla tamamladı.",
    careerText2: "Türkiye'ye dönüşünün ardından lise son sınıfını Ankara Atatürk Anadolu Lisesi'nde okuyarak mezun oldu. Tıp eğitimine Marmara Üniversitesi Tıp Fakültesi'nde başladı ve bu kurumu başarıyla tamamlayarak tıp doktoru unvanını aldı.",
    careerText3: "Tıpta Uzmanlık Sınavı ile İstanbul Haydarpaşa Numune Eğitim ve Araştırma Hastanesi Plastik, Rekonstrüktif ve Estetik Cerrahi Anabilim Dalı'na yerleşerek ihtisas sürecini burada sürdürdü. Bu süreçte birçok bilimsel çalışma ve vaka deneyimi elde etti.",
    careerText4: "İhtisas boyunca gösterdiği akademik başarılar ve disiplinli yaklaşımı, sonraki yurt dışı deneyimlerine ve klinik pratiğine zemin oluşturdu. Mezuniyet sonrası kariyeri boyunca hem ulusal hem de uluslararası düzeyde saygın bir konum elde etti.",
    educationAcademic: "Eğitim & Akademik Deneyim",
    educationText1: "İhtisası süresince, Hamburg/Almanya'da GB Hamburg Üniversitesi Çene Cerrahisi Anabilim Dalı'nda çene cerrahisi, Oxford/İngiltere'de ise Oxford Üniversitesi Kraniyofasiyal Cerrahi Anabilim Dalı'nda kraniyofasiyal gelişim bozuklukları alanında klinik gözlemci olarak bulundu. Uzmanlık tezi, estetik cerrahi alanında dünyanın en prestijli bilimsel yayınlarından biri olan Aesthetic Plastic Surgery dergisinde makale olarak yayımlandı (Cin B. 2020 Jun;44(3):1087-1088). Tez haricinde ulusal ve uluslararası birçok akademik dergide makaleleri yayınlandı.",
    educationText2: "28 Eylül 2018 tarihinde Türk Plastik Rekonstrüktif ve Estetik Cerrahi Derneği tarafından düzenlenen yazılı ve sözlü sınavlarda başarı göstererek Yeterlilik Belgesi almaya hak kazandı. 6 Nisan 2019'da Brüksel'de düzenlenen Avrupa Yeterlilik Sınavlarını da başarıyla tamamlayarak, European Board of Plastic, Reconstructive and Aesthetic Surgery tarafından akredite edildi. 2021–2022 yılları arasında Okan Üniversitesi Tıp Fakültesi Plastik Cerrahi Anabilim Dalı'nda Dr. Öğretim Üyesi olarak görev aldı. 2021 yılından bu yana ise İstanbul'daki özel muayenehanesinde serbest hekim olarak hastalarını kabul etmektedir.",
    appointmentInfo: "Randevu ve Bilgi",
    appointmentDescription: "Size en uygun zamanda randevu almak ve detaylı bilgi için hemen iletişime geçin."
  },
  skinFiller: {
    title: 'Cilt Dolgusu',
    description: 'Cilt dolgusu, yüz hatlarınızı gençleştirmek ve hacim kaybını gidermek için kullanılan etkili bir estetik uygulamadır.',
    hero: {
      title: 'Cilt Dolgusu ile Doğal ve Genç Görünüm',
      description: 'Uzman doktorlarımız tarafından uygulanan cilt dolgusu ile yüz hatlarınızı gençleştirin ve hacim kaybını giderin.',
      appointmentButton: 'Randevu Al',
      learnMoreButton: 'Detaylı Bilgi'
    },
    content: {
      whatIs: {
        description: 'Cilt dolgusu, yüz hatlarınızı gençleştirmek ve hacim kaybını gidermek için kullanılan etkili bir estetik uygulamadır. Bu işlem, cildin altına enjekte edilen dolgu maddeleri ile yüz hatlarının daha dolgun ve genç görünmesini sağlar.',
        materials: 'En yaygın kullanılan dolgu maddeleri hyaluronik asit ve kalsiyum hidroksiapatittir. Bu maddeler vücut tarafından doğal olarak emilebilir ve güvenli bir şekilde kullanılabilir.'
      },
      why: {
        title: 'Neden Cilt Dolgusu?',
        reasons: [
          'Yüz hatlarını gençleştirir',
          'Hacim kaybını giderir',
          'Kırışıklıkları azaltır',
          'Doğal görünüm sağlar',
          'Hızlı ve etkili sonuç verir',
          'Minimum iyileşme süresi'
        ]
      },
      how: {
        title: 'Nasıl Uygulanır?',
        description: 'Cilt dolgusu uygulaması, uzman doktorlarımız tarafından klinik ortamında gerçekleştirilir. İşlem öncesi detaylı bir konsültasyon yapılır ve kişiye özel bir tedavi planı oluşturulur.',
        process: 'Uygulama sırasında, seçilen dolgu maddesi ince iğneler ile cildin altına enjekte edilir. İşlem genellikle 30-45 dakika sürer ve lokal anestezi altında gerçekleştirilir.'
      },
      who: {
        title: 'Kimler İçin Uygundur?',
        description: 'Cilt dolgusu, yüz hatlarında hacim kaybı yaşayan, kırışıklıkları olan ve daha genç bir görünüm isteyen kişiler için uygundur.',
        volumeLoss: 'Özellikle yanaklar, şakaklar ve çene hattında hacim kaybı yaşayan kişiler için ideal bir çözümdür.'
      },
      benefits: {
        title: 'Faydaları',
        natural: 'Cilt dolgusu, doğal görünümlü sonuçlar sağlar. Uygulama sonrası yüz hatlarınız daha dolgun ve genç görünür, ancak bu değişim doğal ve dengeli bir şekilde gerçekleşir.'
      }
    },
    quickInfo: {
      title: 'Hızlı Bilgiler',
      duration: 'İşlem Süresi',
      anesthesia: 'Anestezi',
      recovery: 'İyileşme Süresi'
    },
    faq: {
      title: 'Sıkça Sorulan Sorular',
      questions: [
        {
          question: 'Cilt dolgusu ne kadar sürer?',
          answer: 'Cilt dolgusu uygulaması genellikle 30-45 dakika sürer. Sonuçlar hemen görülür ve 6-12 ay arasında devam eder.'
        },
        {
          question: 'Cilt dolgusu ağrılı mıdır?',
          answer: 'İşlem sırasında minimal bir rahatsızlık hissedilebilir, ancak lokal anestezi kullanıldığı için ağrı olmaz.'
        },
        {
          question: 'İyileşme süresi ne kadardır?',
          answer: 'Cilt dolgusu sonrası iyileşme süresi oldukça kısadır. Genellikle 1-2 gün içinde normal aktivitelere dönülebilir.'
        }
      ]
    },
    pricing: {
      title: 'Fiyatlandırma',
      hyaluronic: {
        title: 'Hyaluronik Asit Dolgu',
        price: '500 - 1.000 USD',
        note: 'Kullanılan dolgu miktarına göre değişiklik gösterir'
      },
      calcium: {
        title: 'Kalsiyum Hidroksiapatit Dolgu',
        price: '800 - 1.500 USD',
        note: 'Kullanılan dolgu miktarına göre değişiklik gösterir'
      },
      lips: {
        title: 'Dudak Dolgusu',
        price: '400 - 800 USD',
        note: 'Kullanılan dolgu miktarına göre değişiklik gösterir'
      },
      jawline: {
        title: 'Çene Hattı Dolgusu',
        price: '600 - 1.200 USD',
        note: 'Kullanılan dolgu miktarına göre değişiklik gösterir'
      },
      note: '* Fiyatlar kullanılan dolgu miktarına ve uygulama bölgesine göre değişiklik gösterebilir.'
    }
  },
  contact: {
    title: 'İletişim',
    contactInfo: {
      title: 'İletişim Bilgileri',
      address: {
        title: 'Adres',
        content: 'Koşuyolu Mahallesi Mehmet Akfan Sokak No:19-21 Kadıköy İstanbul Türkiye'
      },
      phone: {
        title: 'Telefon',
        content: '+90 555 123 4567'
      },
      email: {
        title: 'E-posta',
        content: 'drbariscin86@gmail.com'
      }
    },
    workingHours: {
      title: 'Çalışma Saatleri',
      days: [
        { name: 'Pazartesi - Cuma', hours: '09:00 - 18:00' },
        { name: 'Cumartesi', hours: '09:00 - 14:00' },
        { name: 'Pazar', hours: 'Kapalı' }
      ]
    }
  },
}; 